import type { IconWrapperProps } from '@/core/components/icon/icon-wrapper';
import type { SVGIconProps } from '@/core/components/icon/svg-icon';

import SpinnerIcon from '@/assets/icons/spinner';
import color from '@/core/features/styles/color';

export default function LoadingSpinnerIcon(props: SVGIconProps & IconWrapperProps) {
    const { className, color: iconColor = color('black') } = props;
    return (
        <div className={`loadingSpinner ${className ?? ''}`}>
            <SpinnerIcon
                color={iconColor}
                height={props.height}
                onClick={props.onClick}
                width={props.width}
            />
            <style jsx>{`
                .loadingSpinner {
                    animation: spin 900ms linear infinite;
                    animation-name: spin;
                    animation-iteration-count: infinite;
                    animation-timing-function: linear;
                }
                @keyframes spin {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }
            `}</style>
        </div>
    );
}
